// utils.js
import moment from "moment";
import i18n from "@/i18n";

export function formatNumber(num, lang) {
  if (num == null) return "";
  if (lang === "ar") {
    return toArabicNumerals(num);
  } else {
    return new Intl.NumberFormat(lang).format(num);
  }
}

export function formatDate(date) {
  if (!date) return "";
  const parsedDate = new Date(date);
  if (isNaN(parsedDate.getTime())) return date;
  return moment(parsedDate).format("DD/MM/YYYY, hh:mm:ss A");
}

export function toArabicNumerals(num) {
  return num.toString().replace(/\d/g, (d) => "٠١٢٣٤٥٦٧٨٩"[d]);
}

export function formatArabicDate(dateStr, lang) {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) {
    return dateStr;
  }

  const year = date.getFullYear().toString();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const seconds = date.getSeconds().toString().padStart(2, "0");

  let formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

  if (lang === "ar") {
    formattedDate = formattedDate.replace(/\d/g, (d) => "٠١٢٣٤٥٦٧٨٩"[d]);
  }

  return formattedDate;
}

export function formatPercentage(total, value, lang) {
  if (total == null || value == null) return "";
  if (total === 0) {
    return formatNumber(0, lang) + "٪";
  } else if (total > 0) {
    let perct = (value / total) * 100;
    let formattedPercentage = (Math.round(perct * 100) / 100).toFixed(2);
    if (lang === "ar") {
      formattedPercentage = toArabicNumerals(formattedPercentage);
    }
    return formattedPercentage + "٪";
  }
}

export function formatDuration(duration, lang) {
  if (!duration) return "";
  const [hours, minutes, seconds] = duration.split(":").map(Number);
  if (lang === "ar") {
    return `${toArabicNumerals(hours)}:${toArabicNumerals(
      minutes
    )}:${toArabicNumerals(seconds)}`;
  }
  return `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
}

export function getTime(date) {
  if (!date) return "";
  const parsedDate = new Date(date);
  const time = parsedDate.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
  return time ?? "";
}

export function getDate(date) {
  if (!date) return "";
  const parsedDate = new Date(date);
  const day = parsedDate.getDate().toString().padStart(2, "0");
  const month = (parsedDate.getMonth() + 1).toString().padStart(2, "0");
  const year = parsedDate.getFullYear();
  return `${day}-${month}-${year}`;
}


export function setStatus(status) {
  if (status == 1) {
    return {
      status: i18n.global.t("reports.agent_status_report.status_online"),
      class: "bg-primary-50 text-primary-500",
      badgeClass: "bg-primary-500",
    };
  } else if (status == 2) {
    return {
      status: i18n.global.t("reports.agent_status_report.status_rest"),
      class: "bg-orange-50 text-orange-900",
      badgeClass: "bg-orange-900",
    };
  } else if (status == 3) {
    return {
      status: i18n.global.t("reports.agent_status_report.status_busy"),
      class: "bg-yellow-50 text-yellow-900",
      badgeClass: "bg-yellow-900",
    };
  } else {
    return {
      status: i18n.global.t("reports.agent_status_report.status_offline"),
      class: "bg-red-50 text-red-900",
      badgeClass: "bg-red-900",
    };
  }
}